import { apiClient } from '../config/api';

export const reportsService = {
  // Get available reports
  getAvailableReports: () => apiClient.get('/api/reports'),

  // Natural-language query → structured report + filters (in-house parser)
  parseQuery: (q) => apiClient.post('/api/reports/nlq', { q }),

  // Chargeback Summary Report
  getChargebackSummary: (filters = {}) => 
    apiClient.get('/api/reports/chargeback-summary', { params: filters }),

  // Customer Analysis Report
  getCustomerAnalysis: (filters = {}) => 
    apiClient.get('/api/reports/customer-analysis', { params: filters }),

  // Product Performance Report
  getProductPerformance: (filters = {}) => 
    apiClient.get('/api/reports/product-performance', { params: filters }),

  // Financial Summary Report
  getFinancialSummary: (filters = {}) => 
    apiClient.get('/api/reports/financial-summary', { params: filters }),

  // Contract Performance Report
  getContractPerformance: (filters = {}) => 
    apiClient.get('/api/reports/contract-performance', { params: filters }),

  // Batch Processing Report
  getBatchProcessing: (filters = {}) => 
    apiClient.get('/api/reports/batch-processing', { params: filters }),

  // System Audit Report (Admin only)
  getSystemAudit: (filters = {}) => 
    apiClient.get('/api/reports/system-audit', { params: filters }),

  // Export Report
  exportReport: (reportType, format, filters = {}) => 
    apiClient.post(`/api/reports/export/${reportType}`, { format, filters }),

  // Download Exported File
  downloadFile: (filename) => 
    apiClient.get(`/api/reports/download/${filename}`, { responseType: 'blob' })
};
